import React from 'react';
import { orchard } from '../theme';

/* CORE product mark — a core inside two open orbits (the engine).
   Deliberately not the cherry: CORE is the white-label product,
   Cherry-Pick is one studio running on it. Colors are props so the
   mark can sit on dark or light surfaces. */
export default function CoreMark({
  size = 32,
  core = orchard.cherry,
  rings = orchard.ink,
  style,
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      role="img"
      aria-label="CORE"
      style={style}
    >
      <circle cx="24" cy="24" r="7" fill={core} />
      {/* inner orbit — открытая дуга */}
      <path
        d="M24 10 a14 14 0 1 1 -13.4 18"
        stroke={rings}
        strokeWidth="2.6"
        strokeLinecap="round"
      />
      {/* outer orbit — противоположный разрыв */}
      <path
        d="M24 44 a20 20 0 1 1 18.5 -27.5"
        stroke={rings}
        strokeWidth="2"
        strokeLinecap="round"
        opacity="0.45"
      />
    </svg>
  );
}
